export const Common = {
  HTTP_HEADER: 'http://',

  HOST: 'leads.qq.com',

  LEADS_DOWNLOAD: '/api/v1/leads/list_download',
  ASSOCIATE_DOWNLOAD: '/api/v1/leads/associate_list_download',
  CONSULT_DOWNLOAD: '/api/v1/leads/consult_list_download',
  sidebar_auth_url: '/api/v1/wx_work/auth_url/1/qwsidebar',
  qw_auth_url: '/api/v1/wx_work/auth_url/1/customerList',

  LEADS_CALL_RECORD_DOWNLOAD: '/api/v1/leads/call_record_list_download',
  LEADS_PAY_RECORD_DOWNLOAD: '/api/v1/invalid_pay/download_detail',
  LEADS_ANALYSIS_DOWNLOAD_GROUP: '/api/v1/employee_statement/download_user_group_data',
  LEADS_ANALYSIS_DOWNLOAD_EMPLOYEE: '/api/v1/employee_statement/download_user_data',

  LEADS_DMP_DETAIL_UPLOAD_DOWNLOAD: '/api/v1/report_dmp_statement/detail_data_download',
  LEADS_ACTION_DETAIL_UPLOAD_DOWNLOAD: '/api/v1/report_dmp_action/detail_data_download',

  DURATION_2_SEC: 2000,
  DURATION_1_SEC: 1000,
};

export const LeadsDataFilterShortcut = [
  { startRelativeDate: 0, endRelativeDate: 0, label: '今天' },
  { startRelativeDate: -1, endRelativeDate: -1, label: '昨天' },
  { startRelativeDate: -6, endRelativeDate: 0, label: '最近7天' },
  { startRelativeDate: -29, endRelativeDate: 0, label: '最近30天' },
  { startRelativeDate: 1 - (new Date().getDate()), endRelativeDate: 0, label: '当月' },
];
